import renderAmountField from 'components/FormControls/amountField'
import PropTypes from 'prop-types'
import React from 'react'
import { Field } from 'redux-form'
import styles from 'modules/Forms/Billing/Billing-forms.module.scss'
import dropdownRender from 'components/FormControls/dropdown'

export const Amount = ({
  className = '',
  currencies = null,
  currency = null,
  name = 'amount',
  currencyName = 'currency',
  label = 'amount',
  t = () => {},
  ...rest
}) => (
  <div className={className}>
    <Field
      label={label}
      fullWidth
      name={name}
      type="text"
      component={renderAmountField}
      t={t}
      autocomplete="off"
      maxLength={14}
      format={(value) => (value === null ? '' : '' + value)}
      parse={(value) => value.replace(/\s/g, '').replace(',', '.')}
      InputProps={{
        endAdornment:
          currencies?.length > 1 ? (
            <Field
              name={currencyName}
              options={currencies.map(({ currency, name }) => ({
                value: currency,
                label: name,
              }))}
              buttonClass={styles['billing__select-button']}
              disabled={rest.disabled}
              component={dropdownRender}
            />
          ) : (
            currency
          ),
      }}
      {...rest}
    />
  </div>
)

Amount.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  helperText: PropTypes.string,
  t: PropTypes.func,
  currencies: PropTypes.oneOfType([PropTypes.array, PropTypes.oneOf([null])]),
  currency: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
  amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  currencyName: PropTypes.string,
}
